import { SenecFPPTheme } from "src/styles/fpp-theme/theme.types";
import { inputBorderRadiusMedium } from "src/styles/components/constants";

export const senecAutocompleteTheme = (theme: SenecFPPTheme) => {
    return {
        styleOverrides: {
            paper: {
                borderRadius: inputBorderRadiusMedium,
                boxShadow: "0px 12px 24px 0px rgba(43, 43, 43, 0.08)",
            },
            listbox: {
                borderRadius: "12px",
                padding: ".5rem",
                "& .MuiAutocomplete-option": {
                    borderRadius: inputBorderRadiusMedium,
                    padding: ".5rem",
                    "&:hover": {
                        background: theme.palette.neutralGray20.main,
                    },
                },
                "& .MuiAutocomplete-option[aria-selected='true'], & .MuiAutocomplete-option[aria-selected='true'].Mui-focused": {
                    background: theme.palette.neutralGray000.main,
                },
            },
            clearIndicator: {
                padding: 0,
                visibility: "visible !important",
                "&:hover": {
                    background: "none",
                },
            },
            root: {
                ".MuiInputBase-root": {
                    input: {
                        paddingLeft: "7px !important",
                        transform: "translateY(1px)",
                    },
                },
            },
        },
    };
};
